<template>


    <button @click="shareViaWhatsapp">
        <share-via-whatsapp></share-via-whatsapp>
    </button>

    <button @click="shareViaTwitter">
        <share-via-twitter></share-via-twitter>
    </button>

    <button v-if="!isDesktopDevice" @click="shareViaMessenger">
        <share-via-messenger></share-via-messenger>
    </button>

    <button v-if="!isDesktopDevice" @click="genericShare">
        <generic-share-button></generic-share-button>
    </button>


</template>



<script>

import log from 'loglevel';
import { isDesktop } from "@/utils/utils.ts";
import ShareViaTwitter from '@/icons/ShareViaTwitter.vue';
import ShareViaWhatsapp from '@/icons/ShareViaWhatsapp.vue';
import ShareViaMessenger from '@/icons/ShareViaMessenger.vue';
import GenericShareButton from '@/icons/GenericShareButton.vue';

export default {
    name: 'ShareButtons',
    props: {
        referralCode: String,
        baseUrl: String,
    },
    components: {
        ShareViaTwitter,
        ShareViaWhatsapp,
        ShareViaMessenger,
        GenericShareButton,
    },
    setup() {
        const isDesktopDevice = isDesktop();
        return {
            isDesktopDevice,
        };
    },
    methods: {
        shareViaWhatsapp() {
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Use my referral here: ${this.baseUrl}/referral/${this.referralCode}`)}`;
            window.open(whatsappUrl, '_blank');
        },
        shareViaTwitter() {
            const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(`Use my referral here: ${this.baseUrl}/referral/${this.referralCode}`)}`;
            window.open(twitterUrl, '_blank');
        },
        shareViaMessenger() {
            const messengerUrl = `fb-messenger://share?link=${encodeURIComponent(this.baseUrl + '?referral=' + this.referralCode)}&app_id=${import.meta.env.VITE_APP_FACEBOOK_CLIENT_ID}`;
            window.open(messengerUrl, '_blank');
        },
        genericShare() {
            if (!this.isDesktopDevice && navigator.share) {
                navigator.share({
                    text: `Use my referral link: ${this.baseUrl}/referral/${this.referralCode}`,
                }).catch(() => {
                    // Ignore all share cancellation errors
                    return;
                });
            } else {
                alert('Sharing is only available on mobile devices.');
            }
        },
    },
}

</script>
